export const scrollToView = (e) => {
  e?.scrollIntoViewIfNeeded();
};
